var map = {
	"./anchor.png": "5a53",
	"./apple_podcasts.png": "da8b",
	"./breaker.png": "fd25",
	"./castbox.png": "b8d3",
	"./google_podcasts_outline.png": "36ef",
	"./overcast.png": "4b85",
	"./pocket_casts.png": "fcf7",
	"./radiopublic.png": "a3dd",
	"./spotify.png": "695a",
	"./stitcher.png": "f668"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ca5";